import { CustomFormItem } from "@src/components/CustomForm";
import CustomInput from "@src/components/CustomInput";

export const getInput = (props, placeholder, required, name) => {
  const getCurrentLanguage = () => localStorage.getItem('language')?.slice(1, -1);

  const isEnglishLanguage = () => getCurrentLanguage() === 'en';
  const isEnglish = isEnglishLanguage();
  return (
    <CustomFormItem
      name={name}
      rules={[{ required: required, message: isEnglish ? 'This field is required.' : 'Bu Alan Zorunludur.' }]}
      style={{ fontSize: '8px' }}
    >
      <CustomInput
        id="ticketRestaurant-manageMyCards-activeCardList-getInput-input"
        {...props}
        placeholder={placeholder}
        height={36}
      />
    </CustomFormItem>
  );
};